'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { PoppyBadge } from '@/components/shared/PoppyBadge';
import { DismissPoppyBadgeButton } from '@/components/shared/DismissPoppyBadgeButton';
interface PoppyBadgeWrapperProps {
  landingPageId: string;
  isOwner: boolean;
}
export function PoppyBadgeWrapper(t0) {
  const $ = _c(6);
  const {
    landingPageId,
    isOwner
  } = t0;
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PoppyBadge />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isOwner || $[2] !== landingPageId) {
    t2 = isOwner && <DismissPoppyBadgeButton landingPageId={landingPageId} onDismissed={() => setDismissed(true)} />;
    $[1] = isOwner;
    $[2] = landingPageId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="relative inline-flex">{t1}{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}